import Vue from 'vue'
import AxiosPlugin from 'vue-axios-cors';
 
Vue.use(AxiosPlugin)

